export default __webpack_public_path__ + "66850652d70f3850b15940eed3c24f4d.jpg";